import { render, staticRenderFns } from "./HighlightsSubmitIcon.vue?vue&type=template&id=ce3918a2"
import script from "./HighlightsSubmitIcon.vue?vue&type=script&lang=ts"
export * from "./HighlightsSubmitIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports